export enum MeasureEnum {
  Piece = 1,
  Meter,
  LinearMeter,
  SquareMeter,
}
